'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../external/classnames/index.js');
var useIsOverflow = require('../../utilities/hooks/useIsOverflow.js');
var Card = require('../Card/Card.js');
var CardBody = require('../Card/CardBody/CardBody.js');
var CardImage = require('../Card/CardImage/CardImage.js');
require('../Card/CardText/CardText.js');
var CardTitle = require('../Card/CardTitle/CardTitle.js');
require('../../utilities/GatsbyLink/index.js');
require('../../primitives/Hero/Hero.js');
require('../../primitives/HeroSrcSet/HeroSrcSet.js');
require('../../primitives/Icon/Icon.js');
var Link = require('../../primitives/Link/Link.js');
var useMobileBool = require('../../utilities/hooks/useMobileBool.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

/**
 *
 * @param {Object} props
 * @param {string} props.description - description of the event
 * @param {string} props.image - image of the event
 * @param {string} props.title - title of the event
 * @param {string} [props.className] - additional classes to apply to the card
 * @param {string} [props.date] - date of the event
 * @param {string} [props.eventLocation] - location of the event
 * @param {string} [props.link] - link to the event
 * @param {string} [props.linkText] - text for the link
 * @param {'horizontal' | 'vertical'} [props.direction] - direction of the card
 * @param {string} [props.srcSet] - srcSet for the image
 * @param {string} [props.sizes] - sizes for the image
 */
var EventCard = function EventCard(props) {
  var _isOverflow$overflow;
  var className = props.className,
    eventLocation = props.eventLocation,
    date = props.date,
    description = props.description,
    image = props.image,
    link = props.link,
    _props$linkText = props.linkText,
    linkText = _props$linkText === void 0 ? 'Learn More' : _props$linkText,
    title = props.title,
    direction = props.direction,
    srcSet = props.srcSet,
    _props$sizes = props.sizes,
    sizes = _props$sizes === void 0 ? '350px' : _props$sizes;
  var descriptionRef = React.useRef(null);
  var isOverflow = useIsOverflow.useIsOverflow(descriptionRef);
  var _useState = React.useState(false),
    _useState2 = slicedToArray.default(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var showMoreBtn = (_isOverflow$overflow = isOverflow === null || isOverflow === void 0 ? void 0 : isOverflow.overflow) !== null && _isOverflow$overflow !== void 0 ? _isOverflow$overflow : false;
  var currentDirection = useMobileBool.useMobileBool() ? 'vertical' : direction;
  var isVertical = currentDirection === 'vertical';
  var classes = index.default('lanl-event-card', !isVertical && 'horizontal', className);
  var renderTitle = function renderTitle() {
    return isVertical ? /*#__PURE__*/React__default.default.createElement(CardTitle.CardTitle, null, title) : /*#__PURE__*/React__default.default.createElement("h4", {
      className: "title"
    }, title);
  };
  var renderDetails = function renderDetails() {
    return /*#__PURE__*/React__default.default.createElement("h5", {
      className: "details"
    }, date, " ", eventLocation && "| ".concat(eventLocation));
  };
  var renderLink = function renderLink() {
    return link && /*#__PURE__*/React__default.default.createElement(Link.Link, {
      href: link
    }, linkText);
  };
  var renderDescription = function renderDescription() {
    return /*#__PURE__*/React__default.default.createElement("p", {
      className: "description ".concat(showMore ? '' : 'show-less'),
      ref: descriptionRef
    }, description, showMoreBtn && !isVertical && /*#__PURE__*/React__default.default.createElement("button", {
      type: "button",
      className: "read-more",
      onClick: function onClick() {
        return setShowMore(!showMore);
      }
    }, !showMore && /*#__PURE__*/React__default.default.createElement("span", {
      className: "more-ellipsis"
    }, "..."), " Show", ' ', showMore ? 'less' : ' more'));
  };
  if (currentDirection === 'vertical') {
    return /*#__PURE__*/React__default.default.createElement(Card.Card, {
      className: classes,
      "data-testid": "lanl-event-card-vertical"
    }, /*#__PURE__*/React__default.default.createElement(CardImage.CardImage, {
      alt: "".concat(title, " image"),
      srcSet: srcSet,
      src: image,
      sizes: sizes,
      link: link,
      className: "card-image"
    }), /*#__PURE__*/React__default.default.createElement(CardBody.CardBody, null, renderTitle(), renderDetails(), renderDescription(), renderLink()));
  } else {
    return /*#__PURE__*/React__default.default.createElement("div", {
      className: classes,
      "data-testid": "lanl-event-card-horizontal"
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "media-container"
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "div-img"
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "lanl-image-container"
    }, /*#__PURE__*/React__default.default.createElement(CardImage.CardImage, {
      alt: "".concat(title, " image"),
      srcSet: srcSet,
      src: image,
      sizes: sizes,
      link: link,
      className: "card-image"
    })))), /*#__PURE__*/React__default.default.createElement("div", {
      className: "content"
    }, renderTitle(), renderDetails(), renderDescription(), renderLink()));
  }
};
EventCard.defaultProps = {
  direction: 'vertical',
  linkText: 'Learn More',
  sizes: '350px'
};
EventCard.propTypes = {
  description: PropTypes__default.default.string.isRequired,
  image: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string.isRequired,
  className: PropTypes__default.default.string,
  date: PropTypes__default.default.string,
  direction: PropTypes__default.default.oneOf(['horizontal', 'vertical']),
  eventLocation: PropTypes__default.default.string,
  link: PropTypes__default.default.string,
  linkText: PropTypes__default.default.string,
  sizes: PropTypes__default.default.string,
  srcSet: PropTypes__default.default.string
};

exports.EventCard = EventCard;
exports.default = EventCard;
//# sourceMappingURL=EventCard.js.map
